import { useEffect } from 'react';
import { states } from '@/constants/lifecycle';
import Fetch, { fetchConfig } from '@/hooks/fetch';
import { datasetDatasourceFeatureActions } from '../constants';

const useFetchOrInitialiseDatasource = (fetch, fetchTypes, newDatasource, category, code, readStatus, isNew) => {
  useEffect(() => {
    if (isNew) {
      fetchTypes('all');
      newDatasource(category, code);
    } else if (readStatus === states.NONE) {
      fetch(category, code);
    }
  }, [category, code]);
};

export default {
  useFetchDatasourceFeatures: (
    { category, code },
    readStatus,
    config = fetchConfig([category, code, readStatus]),
  ) => Fetch.useFetchDispatch(
    datasetDatasourceFeatureActions.FETCH_DATASOURCE_FEATURES,
    readStatus,
    { category, code },
    config,
  ),
  useFetchOrInitialiseDatasource,
};
